import * as React from 'react';
import { EventBus } from '@/shared/utils';
import { ProfileEventKeys, ProfileEvents } from '../events';
import { Profile } from '@/shared/i18n';
import { ProfileForm } from '../ui/profile-form';
import { useProfile } from '../hooks/use-profile';
import { ProfileActionFeedback } from '../ui/elements';
import { ProfileLoader } from '../../ui/shared/module-loader';
import { Auth } from 'firebase/auth';

interface ProfileScreenProps {
  auth: Auth;
  eventBus: EventBus<ProfileEvents>;
  dict: Profile;
}

const ProfileScreen: React.FC<ProfileScreenProps> = ({ auth, dict, eventBus }) => {
  const { profile, updateProfile, refreshProfile, deleteProfile, resetLoadingState } = useProfile(
    auth,
    dict,
    eventBus,
  );

  React.useEffect(() => {
    eventBus.on(ProfileEventKeys.profile.view, refreshProfile);
    eventBus.on(ProfileEventKeys.profile.update, updateProfile);
    eventBus.on(ProfileEventKeys.profile.delete, deleteProfile);

    return () => {
      eventBus.off(ProfileEventKeys.profile.update, updateProfile);
      eventBus.off(ProfileEventKeys.profile.view, refreshProfile);
      eventBus.off(ProfileEventKeys.profile.delete, deleteProfile);
      resetLoadingState();
    };
  }, [eventBus, refreshProfile, updateProfile, deleteProfile]);

  if (!profile)
    return (
      <>
        <ProfileActionFeedback />
        <ProfileLoader key="profile-loader" />
      </>
    );
  return (
    <>
      <ProfileActionFeedback />
      <ProfileForm dict={dict} eventBus={eventBus} initialValues={profile} />
    </>
  );
};

export default ProfileScreen;
